export const environment = {
  production: false,
  baseUrl: "https://api-dev.lulus-app.com/api/",
};